var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.429V0H15v6H0v5h15v6h2.5v-2.429H20v-2.428h2.5V9.714H25V7.286h-2.5V4.857H20V2.43h-2.5z",
    fill: "currentColor"
  })));
}

var MemoSvgArrowRight = /*#__PURE__*/React.memo(SvgArrowRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyNSAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjUgMi40Mjg1N1YwSDE1VjIuNDI4NTdWNkgxMi41SDEwSDcuNUg1SDIuNUgwVjExSDVINy41SDEwSDEyLjVIMTVWMTQuNTcxNFYxN0gxNy41VjE0LjU3MTRIMjBWMTIuMTQyOUgyMi41VjkuNzE0MjhIMjVWNy4yODU3MUgyMi41VjQuODU3MTRIMjBWMi40Mjg1N0gxNy41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { MemoSvgArrowRight as ReactComponent };